interface MaintenanceConfig {
	enabled: boolean;
	startDate: string;
	endDate: string;
}

export const maintenanceConfig: MaintenanceConfig = {
	enabled: true,
	startDate: '2026-07-13T7:30:00', // Local time (Europe/Rome)
	endDate: '2026-07-13T9:30:00', // Local time (Europe/Rome)
};
